import gsap, { ScrollTrigger } from "gsap/all";
import { Sizes } from "../styles";

const CtaScrollSectionImages = () => {
	gsap.registerPlugin(ScrollTrigger);

	const scrollingCtaBlock = document.querySelector(".scrolling-cta-block");
	
	if (!scrollingCtaBlock) return;

	let mm = gsap.matchMedia();
	const isDesktop = `(min-width: ${Sizes.screens.medium})`;
	mm.add({ isDesktop }, () => {
		const scrollingSections = gsap.utils.toArray(
			".right__content__section:not(:first-child)"
		);
		const photos = gsap.utils.toArray(".left__images__img:not(:first-child)");

		// hide the block title when pinning starts
		const blockTitleAnimation = gsap.to(
			".scrolling-cta-block__title",
			{
				autoAlpha: 0,
				ease: "none",
			}
		);

		// scroll trigger that pins the left side
		ScrollTrigger.create({
			trigger: ".scrolling-cta-block__container",
			start: "100px top",
			end: "bottom bottom",
			pin: ".left",
			animation: blockTitleAnimation,
			toggleActions: "play none none reverse",
			pinSpacing: false,
		});

		// scroll trigger that controls the image animations
		scrollingSections.forEach((section, index) => {
			let sectionTitle = section.querySelector("h3");

			const photoAnimation = gsap.fromTo(
				photos[index],
				{
					autoAlpha: 0,
					zIndex: 1 + index,
					ease: "none",
				},
				{
					autoAlpha: 1,
					zIndex: 1 + index,
					ease: "none",
				},
				0
			);
			ScrollTrigger.create({
				trigger: sectionTitle,
				start: "top 80%",
				end: "top 50%",
				animation: photoAnimation,
				scrub: true,
			});
		});
	});
};

export default CtaScrollSectionImages;
